import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer'
import { createApp, configureCompat } from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import { registreGlobalComponents } from '@components/_globals'
import HoneybadgerVue from '@honeybadger-io/vue'
import browserDetect from 'vue-browser-detect-plugin'
import { VueHeadMixin, createHead } from '@unhead/vue'
import { GlobalProviders } from '@common/GlobalProviders'

configureCompat({
  WATCH_ARRAY: 'suppress-warning',
  RENDER_FUNCTION: 'suppress-warning',
  INSTANCE_LISTENERS: 'suppress-warning',
  COMPONENT_FUNCTIONAL: 'suppress-warning',
  OPTIONS_BEFORE_DESTROY: 'suppress-warning',
  INSTANCE_SCOPED_SLOTS: 'suppress-warning',
  OPTIONS_DATA_MERGE: 'suppress-warning',
  COMPONENT_V_MODEL: 'suppress-warning',
  CUSTOM_DIR: 'suppress-warning',
  INSTANCE_EVENT_EMITTER: 'suppress-warning',
  ATTR_FALSE_VALUE: 'suppress-warning',
  INSTANCE_ATTRS_CLASS_STYLE: 'suppress-warning',
  GLOBAL_PROTOTYPE: 'suppress-warning',
  GLOBAL_EXTEND: 'suppress-warning',
  GLOBAL_MOUNT: 'suppress-warning',
  OPTIONS_DESTROYED: 'suppress-warning',
  INSTANCE_DESTROY: 'suppress-warning',
  CONFIG_PRODUCTION_TIP: 'suppress-warning',
})

export const app = createApp(App)

registreGlobalComponents(app)
app.use(require('bootstrap-vue/dist/bootstrap-vue.common.min'))
app.use(browserDetect)
app.mixin(VueHeadMixin)

// Don't warn about using the dev version of Vue in development.
app.config.productionTip = process.env.NODE_ENV === 'production'

if (process.env.NODE_ENV === 'production') {
  const honeybadgerConfig = {
    apiKey: process.env.VUE_APP_HONEYBADGER_API_KEY,
    environment: process.env.VUE_APP_MONITORING_ENVIRONMENT || 'unspecified',
    revision: process.env.VUE_APP_COMMIT_HASH || 'unspecified',
    beforeNotify: (notice) => {
      const message = notice?.errors?.[0]?.message || notice?.message || ''
      const originalError = notice?.originalError

      const isCanceled =
        originalError?.code === 'ERR_CANCELED' ||
        originalError?.name === 'CanceledError' ||
        notice?.name === 'CanceledError' ||
        message.includes('ERR_CANCELED')

      if (isCanceled) return false
      if (message.includes('ResizeObserver loop limit exceeded')) return false

      return notice
    },
  }
  app.use(HoneybadgerVue, honeybadgerConfig)
}

app.use(router)
app.use(store)
app.use(createHead())

GlobalProviders(app)

app.mount('#app')
